import { useCallback, useState } from 'react';
import { request } from '../common/request';

export interface IBalance {
  value: number;
}

export function useBalance() {
  const [balance, setBalance] = useState<IBalance>();

  const getBalance = useCallback(
    () => {
      request.get<{ data: IBalance }>('/balance')
        .then(response => {
          return setBalance(response.data.data);
        })
        .catch(() => { })
    }, []
  );

  return { balance, getBalance };
}